import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Paper, TextInput } from "@mantine/core";

import { Breadcrumbs } from "../../components/Breadcrumbs";
import { useAuthContext } from "../../hooks/auth";

export interface ProfilePageProps {}
export const ProfilePage = ({}: ProfilePageProps) => {
    const { t } = useTranslation(["common"]);

    const authContext = useAuthContext();

    const [firstName, setFirstName] = useState(authContext?.user?.firstName);
    const [lastName, setLastName] = useState(authContext?.user?.lastName);
    const [email, setEmail] = useState(authContext?.user?.email);

    useEffect(() => {
        setEmail(authContext?.user?.email);
        setLastName(authContext?.user?.lastName);
        setFirstName(authContext?.user?.firstName);
    }, [authContext?.user]);

    return (
        <>
            <Flex align="center" justify="space-between" mb="lg">
                <Breadcrumbs
                    items={[
                        {
                            title: t("editprofile"),
                        },
                    ]}
                />
            </Flex>
            <Paper p="lg" shadow="sm" radius="sm" withBorder>
                <TextInput
                    mb="xs"
                    type="text"
                    label={t("firstname")}
                    placeholder={t("firstname")}
                    value={firstName}
                    onChange={(event) => setFirstName(event.target.value)}
                />
                <TextInput
                    mb="xs"
                    type="text"
                    label={t("lastname")}
                    placeholder={t("lastname")}
                    value={lastName}
                    onChange={(event) => setLastName(event.target.value)}
                />
                <TextInput
                    type="text"
                    label={t("email")}
                    placeholder={t("email")}
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    disabled
                />
            </Paper>
        </>
    );
};
